import { useContext, useRef, useState } from 'react';
import useInput from '../../hooks/use-input';
import Button from '../ui/Button';
import './UserResetPassword.scss';
import AuthContext from '../../store/auth-context';
import { resetPassword } from '../../api/authAPI';
import { useNavigate } from 'react-router-dom';

const UserResetPassword = () => {
	const PwdStrengthRegex =
		/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{6,}$/;

	const {
		value: enteredFuturePass,
		isValid: enteredFuturePasswdIsValid,
		hasError: futurePasswdInputHasError,
		valueChangeHandler: futurePasswdChangedHandler,
		inputBlurHandler: futurePasswdBlurHandler,
		reset: resetFuturePasswdInput
	} = useInput((value) => PwdStrengthRegex.test(value));

	const {
		value: enteredCurrentPasswd,
		isValid: enteredCurrentPasswdIsValid,
		hasError: currentPasswdInputHasError,
		valueChangeHandler: currentPasswdChangedHandler,
		inputBlurHandler: currentPasswdBlurHandler,
		reset: resetCurrentPasswdInput
	} = useInput((value) => value.trim() !== '');

	const repeatFuturePasswd = useRef();
	const navigate = useNavigate();

	const [inputPassHasError, setInputPassHasError] =
		useState('');

	const authCtx = useContext(AuthContext);

	let formIsValid = false;

	if (
		enteredCurrentPasswdIsValid &&
		enteredFuturePasswdIsValid
	) {
		formIsValid = true;
	}
	const futurePasswdClass = futurePasswdInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	const currentPasswdClass = currentPasswdInputHasError
		? 'form-control is-invalid'
		: 'form-control';

	const resetUserPassword = (event) => {
		event.preventDefault();
		const enteredRepeatedPasswd =
			repeatFuturePasswd.current.value;
		if (enteredFuturePass !== enteredRepeatedPasswd) {
			return setInputPassHasError('Passwords do not match');
		}

		resetPassword(
			authCtx.userData.email,
			enteredCurrentPasswd,
			enteredFuturePass
		)
			.then(() => {
				navigate('/dashboard');
			})
			.catch((error) => {
				let errorMessage = error.response.data
					? error.response.data.msg
					: '';
				setInputPassHasError(errorMessage);
			});

		resetCurrentPasswdInput();
		resetFuturePasswdInput;
		setInputPassHasError('');
	};

	const cancelResetPassword = () => {
		resetCurrentPasswdInput();
		resetFuturePasswdInput;
		setInputPassHasError('');
		navigate('/dashboard');
	};
	return (
		<div className='user-reset-password-container'>
			<div className='user-reset-content'>
				<div className='reset-legend-container'>
					<h2>Change Your Password</h2>
					<p className='reset-legend-info-label'>
						The new password must be different from the
						previously used password.
					</p>
					<p className='reset-legend-info-label'>
						Remember it must have at least 6 characters to
						be valid.
					</p>
				</div>
				<form className='reset-password-form-container'>
					<div className='control-container row'>
						<div>
							<div className='form-error-message'>
								{inputPassHasError}
							</div>
							<label>Current Password</label>
							<input
								className={currentPasswdClass}
								id='oldPasswd'
								type='password'
								name='password'
								onChange={currentPasswdChangedHandler}
								onBlur={currentPasswdBlurHandler}
								required
							/>
							<div
								id='validationServerPasswdFeedback'
								className='invalid-feedback'
							>
								Password must contain an upper-case latter,
								a lower-case latter, special character, a
								number and be 6 or more characteres long
							</div>
							<label>New Password</label>
							<input
								className={futurePasswdClass}
								id='password'
								type='password'
								name='password'
								onChange={futurePasswdChangedHandler}
								onBlur={futurePasswdBlurHandler}
								required
							/>
							<div
								id='validationServerPasswdFeedback'
								className='invalid-feedback'
							>
								Password must contain an upper-case latter,
								a lower-case latter, special character, a
								number and be 6 or more characteres long
							</div>
							<label>Confirm New Password</label>
							<input
								className='form-control'
								id='repeat-passwd'
								type='password'
								name='password'
								ref={repeatFuturePasswd}
								required
							/>
						</div>
					</div>
				</form>
			</div>
			<div className='reset-password-controlers'>
				<Button
					className='secondary-button'
					onClick={cancelResetPassword}
				>
					Cancel
				</Button>
				<Button
					className='primary-button'
					disabled={!formIsValid}
					onClick={resetUserPassword}
				>
					Change Password
				</Button>
			</div>
		</div>
	);
};

export default UserResetPassword;
